
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 6.2.1
 * Query Engine version: 4123509d24aa4dede1e864b46351bf2790323b69
 */
Prisma.prismaVersion = {
  client: "6.2.1",
  engine: "4123509d24aa4dede1e864b46351bf2790323b69"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.ChatbotScalarFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  workspaceId: 'workspaceId',
  isLiveChatEnabled: 'isLiveChatEnabled',
  liveChatRoutingMessage: 'liveChatRoutingMessage',
  isIntentRoutingEnabled: 'isIntentRoutingEnabled',
  isSatisfactionSurveyEnabled: 'isSatisfactionSurveyEnabled',
  language: 'language',
  supportedLanguages: 'supportedLanguages',
  isAutoTranslationEnabled: 'isAutoTranslationEnabled',
  openAIApiKey: 'openAIApiKey',
  embedPageVisited: 'embedPageVisited',
  checklistClosed: 'checklistClosed',
  isArchived: 'isArchived',
  isAppsumoUserChatbot: 'isAppsumoUserChatbot',
  isAutoResyncEnabled: 'isAutoResyncEnabled',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  permanentDeleteDate: 'permanentDeleteDate',
  settings: 'settings',
  customize: 'customize'
};

exports.Prisma.AIFunctionScalarFieldEnum = {
  id: 'id',
  chatbotId: 'chatbotId',
  description: 'description',
  webhookUrl: 'webhookUrl',
  method: 'method',
  name: 'name',
  variables: 'variables',
  bodyParams: 'bodyParams',
  fallbackMessage: 'fallbackMessage',
  successMessage: 'successMessage',
  type: 'type',
  authenticationType: 'authenticationType',
  authApiKey: 'authApiKey',
  authType: 'authType',
  authHeaderKey: 'authHeaderKey',
  elements: 'elements',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AIFunctionLogScalarFieldEnum = {
  id: 'id',
  aIFunctionId: 'aIFunctionId',
  chatbotId: 'chatbotId',
  chatId: 'chatId',
  messageId: 'messageId',
  name: 'name',
  status: 'status',
  variables: 'variables',
  response: 'response',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.TranslationScalarFieldEnum = {
  id: 'id',
  chatbotId: 'chatbotId',
  language: 'language',
  key: 'key',
  value: 'value'
};

exports.Prisma.ContactAttributeScalarFieldEnum = {
  id: 'id',
  contactId: 'contactId',
  chatbotId: 'chatbotId',
  key: 'key',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ContactScalarFieldEnum = {
  id: 'id',
  chatSource: 'chatSource',
  email: 'email',
  chatbotId: 'chatbotId',
  distinctId: 'distinctId',
  name: 'name',
  phone: 'phone',
  threadId: 'threadId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ip: 'ip',
  country: 'country'
};

exports.Prisma.LibraryScalarFieldEnum = {
  id: 'id',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  relatedMessageId: 'relatedMessageId',
  url: 'url',
  title: 'title',
  text: 'text',
  source: 'source',
  isGeneratedByAI: 'isGeneratedByAI',
  isImprovedByAI: 'isImprovedByAI',
  status: 'status',
  updatedAt: 'updatedAt',
  createdAt: 'createdAt',
  characterCount: 'characterCount',
  embeddingIds: 'embeddingIds',
  improvedEmbeddingIds: 'improvedEmbeddingIds',
  lastModified: 'lastModified',
  etag: 'etag',
  checksum: 'checksum'
};

exports.Prisma.AudienceScalarFieldEnum = {
  id: 'id',
  chatbotId: 'chatbotId',
  name: 'name',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AudienceLibraryScalarFieldEnum = {
  id: 'id',
  audienceId: 'audienceId',
  libraryId: 'libraryId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FilterGroupScalarFieldEnum = {
  id: 'id',
  audienceId: 'audienceId',
  combinator: 'combinator',
  parentId: 'parentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.FilterRuleScalarFieldEnum = {
  id: 'id',
  groupId: 'groupId',
  key: 'key',
  operator: 'operator',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.ChatScalarFieldEnum = {
  id: 'id',
  contactId: 'contactId',
  chatbotId: 'chatbotId',
  isAgent: 'isAgent',
  isResolved: 'isResolved',
  resolvedBy: 'resolvedBy',
  resolvedAt: 'resolvedAt',
  resolvedByAgentId: 'resolvedByAgentId',
  isStarred: 'isStarred',
  isMuted: 'isMuted',
  isAIHelped: 'isAIHelped',
  agentId: 'agentId',
  workspaceId: 'workspaceId',
  integrationType: 'integrationType',
  chatType: 'chatType',
  initialPath: 'initialPath',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  lastMessageDate: 'lastMessageDate'
};

exports.Prisma.AgentUnreadChatScalarFieldEnum = {
  agentId: 'agentId',
  chatId: 'chatId',
  createdAt: 'createdAt'
};

exports.Prisma.ContactUnreadChatScalarFieldEnum = {
  contactId: 'contactId',
  chatId: 'chatId',
  createdAt: 'createdAt'
};

exports.Prisma.MessageScalarFieldEnum = {
  id: 'id',
  text: 'text',
  sender: 'sender',
  agentId: 'agentId',
  chatId: 'chatId',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  createdAt: 'createdAt',
  credit: 'credit',
  type: 'type',
  isHumanSupportRequest: 'isHumanSupportRequest',
  isQuotaLimitReached: 'isQuotaLimitReached',
  isIgnoredForImprovement: 'isIgnoredForImprovement',
  isFollowUp: 'isFollowUp'
};

exports.Prisma.MessageEvaluationScalarFieldEnum = {
  id: 'id',
  tag: 'tag',
  potentialGap: 'potentialGap',
  suggestedImprovement: 'suggestedImprovement',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  messageId: 'messageId'
};

exports.Prisma.ChatResolutionLogScalarFieldEnum = {
  id: 'id',
  chatId: 'chatId',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  isAIHelped: 'isAIHelped',
  messageId: 'messageId',
  createdAt: 'createdAt'
};

exports.Prisma.SourceScalarFieldEnum = {
  id: 'id',
  type: 'type',
  link: 'link',
  distance: 'distance',
  messageId: 'messageId',
  embeddingId: 'embeddingId',
  chatbotId: 'chatbotId'
};

exports.Prisma.SourceAudienceLogScalarFieldEnum = {
  id: 'id',
  sourceId: 'sourceId',
  audienceId: 'audienceId',
  audienceName: 'audienceName',
  audienceQueryLog: 'audienceQueryLog',
  contactAttributeLog: 'contactAttributeLog',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WorkspaceScalarFieldEnum = {
  id: 'id',
  name: 'name',
  avatar: 'avatar',
  planId: 'planId',
  stripeId: 'stripeId',
  source: 'source',
  industry: 'industry',
  useCase: 'useCase',
  isSuspended: 'isSuspended',
  onboardingMeetingStatus: 'onboardingMeetingStatus',
  onboardingStatus: 'onboardingStatus',
  domainCms: 'domainCms',
  cmsChecked: 'cmsChecked',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  planCreatedAt: 'planCreatedAt',
  isAgency: 'isAgency',
  parentId: 'parentId'
};

exports.Prisma.InvitationScalarFieldEnum = {
  id: 'id',
  email: 'email',
  code: 'code',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expireDate: 'expireDate',
  workspaceId: 'workspaceId',
  isEmailNotificationEnabled: 'isEmailNotificationEnabled',
  role: 'role'
};

exports.Prisma.ResetPasswordTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  status: 'status',
  createdAt: 'createdAt',
  expireDate: 'expireDate',
  userId: 'userId'
};

exports.Prisma.ApiAccessTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  scope: 'scope',
  lastUsedAt: 'lastUsedAt',
  createdAt: 'createdAt',
  workspaceId: 'workspaceId'
};

exports.Prisma.ApiAccessTokenUsageLogScalarFieldEnum = {
  id: 'id',
  tokenId: 'tokenId',
  path: 'path',
  createdAt: 'createdAt'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  avatar: 'avatar',
  name: 'name',
  email: 'email',
  password: 'password',
  phoneNumber: 'phoneNumber',
  provider: 'provider',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WorkspaceAccessScalarFieldEnum = {
  workspaceId: 'workspaceId',
  userId: 'userId',
  role: 'role',
  isEmailNotificationEnabled: 'isEmailNotificationEnabled',
  emailOptIn: 'emailOptIn',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastUsedAt: 'lastUsedAt'
};

exports.Prisma.PlanScalarFieldEnum = {
  id: 'id',
  name: 'name',
  price: 'price',
  interval: 'interval',
  stripePriceId: 'stripePriceId',
  chatbotLimit: 'chatbotLimit',
  messageLimit: 'messageLimit',
  characterLimit: 'characterLimit',
  websiteLimit: 'websiteLimit',
  userLimit: 'userLimit',
  hasAIFunction: 'hasAIFunction',
  hasMakeIntegration: 'hasMakeIntegration',
  hasSlackIntegration: 'hasSlackIntegration',
  hasWhatsAppIntegration: 'hasWhatsAppIntegration',
  hasSyncFeature: 'hasSyncFeature',
  hasBranding: 'hasBranding',
  hasApiAccess: 'hasApiAccess',
  hasCustomCSS: 'hasCustomCSS',
  hasCollectUserData: 'hasCollectUserData',
  hasCustomOpenAIAPI: 'hasCustomOpenAIAPI',
  hasLogoMergeFeature: 'hasLogoMergeFeature',
  hasAIBoostFeature: 'hasAIBoostFeature',
  apiAccessScope: 'apiAccessScope',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AddOnPackageScalarFieldEnum = {
  id: 'id',
  name: 'name',
  price: 'price',
  interval: 'interval',
  stripePriceId: 'stripePriceId',
  chatbotLimit: 'chatbotLimit',
  messageLimit: 'messageLimit',
  seatLimit: 'seatLimit',
  characterLimit: 'characterLimit',
  hasAutoResync: 'hasAutoResync',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WorkspaceAddOnPackageScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  packageId: 'packageId',
  stripePaymentId: 'stripePaymentId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  endAt: 'endAt'
};

exports.Prisma.MailLogScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId',
  email: 'email',
  subject: 'subject',
  content: 'content',
  isSent: 'isSent',
  createdAt: 'createdAt',
  isQuotaMail: 'isQuotaMail',
  isOutdated: 'isOutdated'
};

exports.Prisma.TokenLogScalarFieldEnum = {
  id: 'id',
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId',
  operation: 'operation',
  inputToken: 'inputToken',
  outputToken: 'outputToken',
  createdAt: 'createdAt'
};

exports.Prisma.AppSumoCodeScalarFieldEnum = {
  id: 'id',
  appsumocode: 'appsumocode',
  usage: 'usage',
  workspaceId: 'workspaceId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.WhatsappIntegrationScalarFieldEnum = {
  id: 'id',
  phoneNumber: 'phoneNumber',
  phoneNumberId: 'phoneNumberId',
  token: 'token',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  verifyToken: 'verifyToken',
  verified: 'verified',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SlackAppInstallationScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  appId: 'appId',
  enterpriseId: 'enterpriseId',
  enterpriseName: 'enterpriseName',
  enterpriseUrl: 'enterpriseUrl',
  teamId: 'teamId',
  teamName: 'teamName',
  botToken: 'botToken',
  botId: 'botId',
  botUserId: 'botUserId',
  botScopes: 'botScopes',
  botRefreshToken: 'botRefreshToken',
  botTokenExpiresAt: 'botTokenExpiresAt',
  userId: 'userId',
  userToken: 'userToken',
  userScopes: 'userScopes',
  userRefreshToken: 'userRefreshToken',
  userTokenExpiresAt: 'userTokenExpiresAt',
  incomingWebhookUrl: 'incomingWebhookUrl',
  incomingWebhookChannel: 'incomingWebhookChannel',
  incomingWebhookChannelId: 'incomingWebhookChannelId',
  incomingWebhookConfigurationUrl: 'incomingWebhookConfigurationUrl',
  isEnterpriseInstall: 'isEnterpriseInstall',
  tokenType: 'tokenType',
  installedAt: 'installedAt',
  chatbotId: 'chatbotId',
  apiToken: 'apiToken'
};

exports.Prisma.ErrorLogScalarFieldEnum = {
  id: 'id',
  type: 'type',
  timestamp: 'timestamp',
  url: 'url',
  userId: 'userId',
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId',
  errorType: 'errorType',
  errorText: 'errorText',
  createdAt: 'createdAt'
};

exports.Prisma.ResyncLogScalarFieldEnum = {
  id: 'id',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  newUrls: 'newUrls',
  updatedUrls: 'updatedUrls',
  deletedUrls: 'deletedUrls',
  newUrlsCount: 'newUrlsCount',
  updatedUrlsCount: 'updatedUrlsCount',
  deletedUrlsCount: 'deletedUrlsCount',
  createdAt: 'createdAt'
};

exports.Prisma.AllowedContactAttributeScalarFieldEnum = {
  id: 'id',
  key: 'key',
  chatbotId: 'chatbotId',
  status: 'status',
  dataType: 'dataType',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SuggestionMessagesViewScalarFieldEnum = {
  aiMessageId: 'aiMessageId',
  aiMessageText: 'aiMessageText',
  lastUserMessageId: 'lastUserMessageId',
  lastUserMessageText: 'lastUserMessageText',
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId',
  chatId: 'chatId',
  evaluationTag: 'evaluationTag',
  potentialGap: 'potentialGap',
  suggestedImprovement: 'suggestedImprovement',
  createdAt: 'createdAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.ChatbotOrderByRelevanceFieldEnum = {
  id: 'id',
  slug: 'slug',
  name: 'name',
  workspaceId: 'workspaceId',
  liveChatRoutingMessage: 'liveChatRoutingMessage',
  language: 'language',
  supportedLanguages: 'supportedLanguages',
  openAIApiKey: 'openAIApiKey'
};

exports.Prisma.AIFunctionOrderByRelevanceFieldEnum = {
  id: 'id',
  chatbotId: 'chatbotId',
  description: 'description',
  webhookUrl: 'webhookUrl',
  method: 'method',
  name: 'name',
  fallbackMessage: 'fallbackMessage',
  successMessage: 'successMessage',
  authApiKey: 'authApiKey',
  authHeaderKey: 'authHeaderKey'
};

exports.Prisma.AIFunctionLogOrderByRelevanceFieldEnum = {
  aIFunctionId: 'aIFunctionId',
  chatbotId: 'chatbotId',
  chatId: 'chatId',
  messageId: 'messageId',
  name: 'name',
  response: 'response'
};

exports.Prisma.TranslationOrderByRelevanceFieldEnum = {
  chatbotId: 'chatbotId',
  language: 'language',
  key: 'key',
  value: 'value'
};

exports.Prisma.ContactAttributeOrderByRelevanceFieldEnum = {
  contactId: 'contactId',
  chatbotId: 'chatbotId',
  key: 'key',
  value: 'value'
};

exports.Prisma.ContactOrderByRelevanceFieldEnum = {
  id: 'id',
  chatSource: 'chatSource',
  email: 'email',
  chatbotId: 'chatbotId',
  distinctId: 'distinctId',
  name: 'name',
  phone: 'phone',
  threadId: 'threadId',
  ip: 'ip',
  country: 'country'
};

exports.Prisma.LibraryOrderByRelevanceFieldEnum = {
  id: 'id',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  relatedMessageId: 'relatedMessageId',
  url: 'url',
  title: 'title',
  text: 'text',
  embeddingIds: 'embeddingIds',
  improvedEmbeddingIds: 'improvedEmbeddingIds',
  lastModified: 'lastModified',
  etag: 'etag',
  checksum: 'checksum'
};

exports.Prisma.AudienceOrderByRelevanceFieldEnum = {
  chatbotId: 'chatbotId',
  name: 'name'
};

exports.Prisma.AudienceLibraryOrderByRelevanceFieldEnum = {
  libraryId: 'libraryId'
};

exports.Prisma.FilterRuleOrderByRelevanceFieldEnum = {
  key: 'key',
  value: 'value'
};

exports.Prisma.ChatOrderByRelevanceFieldEnum = {
  id: 'id',
  contactId: 'contactId',
  chatbotId: 'chatbotId',
  resolvedByAgentId: 'resolvedByAgentId',
  agentId: 'agentId',
  workspaceId: 'workspaceId',
  initialPath: 'initialPath'
};

exports.Prisma.AgentUnreadChatOrderByRelevanceFieldEnum = {
  agentId: 'agentId',
  chatId: 'chatId'
};

exports.Prisma.ContactUnreadChatOrderByRelevanceFieldEnum = {
  contactId: 'contactId',
  chatId: 'chatId'
};

exports.Prisma.MessageOrderByRelevanceFieldEnum = {
  id: 'id',
  text: 'text',
  agentId: 'agentId',
  chatId: 'chatId',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId'
};

exports.Prisma.MessageEvaluationOrderByRelevanceFieldEnum = {
  id: 'id',
  potentialGap: 'potentialGap',
  suggestedImprovement: 'suggestedImprovement',
  messageId: 'messageId'
};

exports.Prisma.ChatResolutionLogOrderByRelevanceFieldEnum = {
  chatId: 'chatId',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  messageId: 'messageId'
};

exports.Prisma.SourceOrderByRelevanceFieldEnum = {
  id: 'id',
  link: 'link',
  messageId: 'messageId',
  embeddingId: 'embeddingId',
  chatbotId: 'chatbotId'
};

exports.Prisma.SourceAudienceLogOrderByRelevanceFieldEnum = {
  sourceId: 'sourceId',
  audienceName: 'audienceName'
};

exports.Prisma.WorkspaceOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  avatar: 'avatar',
  stripeId: 'stripeId',
  industry: 'industry',
  useCase: 'useCase',
  domainCms: 'domainCms',
  parentId: 'parentId'
};

exports.Prisma.InvitationOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  code: 'code',
  workspaceId: 'workspaceId'
};

exports.Prisma.ResetPasswordTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  token: 'token',
  userId: 'userId'
};

exports.Prisma.ApiAccessTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  token: 'token',
  workspaceId: 'workspaceId'
};

exports.Prisma.ApiAccessTokenUsageLogOrderByRelevanceFieldEnum = {
  tokenId: 'tokenId',
  path: 'path'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  avatar: 'avatar',
  name: 'name',
  email: 'email',
  password: 'password',
  phoneNumber: 'phoneNumber'
};

exports.Prisma.WorkspaceAccessOrderByRelevanceFieldEnum = {
  workspaceId: 'workspaceId',
  userId: 'userId'
};

exports.Prisma.PlanOrderByRelevanceFieldEnum = {
  name: 'name',
  stripePriceId: 'stripePriceId'
};

exports.Prisma.AddOnPackageOrderByRelevanceFieldEnum = {
  name: 'name',
  stripePriceId: 'stripePriceId'
};

exports.Prisma.WorkspaceAddOnPackageOrderByRelevanceFieldEnum = {
  workspaceId: 'workspaceId',
  stripePaymentId: 'stripePaymentId'
};

exports.Prisma.MailLogOrderByRelevanceFieldEnum = {
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId',
  email: 'email',
  subject: 'subject',
  content: 'content'
};

exports.Prisma.TokenLogOrderByRelevanceFieldEnum = {
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId'
};

exports.Prisma.AppSumoCodeOrderByRelevanceFieldEnum = {
  appsumocode: 'appsumocode',
  workspaceId: 'workspaceId'
};

exports.Prisma.WhatsappIntegrationOrderByRelevanceFieldEnum = {
  id: 'id',
  phoneNumber: 'phoneNumber',
  phoneNumberId: 'phoneNumberId',
  token: 'token',
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  verifyToken: 'verifyToken'
};

exports.Prisma.SlackAppInstallationOrderByRelevanceFieldEnum = {
  clientId: 'clientId',
  appId: 'appId',
  enterpriseId: 'enterpriseId',
  enterpriseName: 'enterpriseName',
  enterpriseUrl: 'enterpriseUrl',
  teamId: 'teamId',
  teamName: 'teamName',
  botToken: 'botToken',
  botId: 'botId',
  botUserId: 'botUserId',
  botScopes: 'botScopes',
  botRefreshToken: 'botRefreshToken',
  userId: 'userId',
  userToken: 'userToken',
  userScopes: 'userScopes',
  userRefreshToken: 'userRefreshToken',
  incomingWebhookUrl: 'incomingWebhookUrl',
  incomingWebhookChannel: 'incomingWebhookChannel',
  incomingWebhookChannelId: 'incomingWebhookChannelId',
  incomingWebhookConfigurationUrl: 'incomingWebhookConfigurationUrl',
  tokenType: 'tokenType',
  chatbotId: 'chatbotId',
  apiToken: 'apiToken'
};

exports.Prisma.ErrorLogOrderByRelevanceFieldEnum = {
  id: 'id',
  url: 'url',
  userId: 'userId',
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId',
  errorType: 'errorType',
  errorText: 'errorText'
};

exports.Prisma.ResyncLogOrderByRelevanceFieldEnum = {
  chatbotId: 'chatbotId',
  workspaceId: 'workspaceId',
  newUrls: 'newUrls',
  updatedUrls: 'updatedUrls',
  deletedUrls: 'deletedUrls'
};

exports.Prisma.AllowedContactAttributeOrderByRelevanceFieldEnum = {
  key: 'key',
  chatbotId: 'chatbotId'
};

exports.Prisma.SuggestionMessagesViewOrderByRelevanceFieldEnum = {
  aiMessageId: 'aiMessageId',
  aiMessageText: 'aiMessageText',
  lastUserMessageId: 'lastUserMessageId',
  lastUserMessageText: 'lastUserMessageText',
  workspaceId: 'workspaceId',
  chatbotId: 'chatbotId',
  chatId: 'chatId',
  potentialGap: 'potentialGap',
  suggestedImprovement: 'suggestedImprovement'
};
exports.AIFunctionType = exports.$Enums.AIFunctionType = {
  MAKE: 'MAKE',
  OPENAPI: 'OPENAPI',
  CUSTOM_WEBHOOK: 'CUSTOM_WEBHOOK',
  ZAPIER: 'ZAPIER',
  RENDER_ELEMENT: 'RENDER_ELEMENT'
};

exports.AIFunctionAuthenticationType = exports.$Enums.AIFunctionAuthenticationType = {
  NONE: 'NONE',
  APIKEY: 'APIKEY',
  OAUTH: 'OAUTH'
};

exports.AIFunctionAuthType = exports.$Enums.AIFunctionAuthType = {
  BASIC: 'BASIC',
  BEARER: 'BEARER',
  CUSTOM: 'CUSTOM'
};

exports.ContentSource = exports.$Enums.ContentSource = {
  WEBSITE: 'WEBSITE',
  TEXT: 'TEXT',
  QA: 'QA',
  PDF: 'PDF',
  YOUTUBE: 'YOUTUBE',
  DOCX: 'DOCX',
  IMAGE: 'IMAGE',
  NOTION: 'NOTION'
};

exports.LibraryStatus = exports.$Enums.LibraryStatus = {
  PENDING: 'PENDING',
  RESYNC: 'RESYNC',
  ARCHIVED: 'ARCHIVED',
  IMPROVE: 'IMPROVE',
  DONE: 'DONE',
  DELETE_AUDIENCE: 'DELETE_AUDIENCE'
};

exports.LogicOperator = exports.$Enums.LogicOperator = {
  AND: 'AND',
  OR: 'OR'
};

exports.ComparisonOperator = exports.$Enums.ComparisonOperator = {
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  IS_SET: 'IS_SET',
  IS_NOT_SET: 'IS_NOT_SET',
  CONTAINS: 'CONTAINS',
  NOT_CONTAINS: 'NOT_CONTAINS',
  IS_GREATER_THAN: 'IS_GREATER_THAN',
  IS_LESS_THAN: 'IS_LESS_THAN',
  IS_GREATER_THAN_OR_EQUAL: 'IS_GREATER_THAN_OR_EQUAL',
  IS_LESS_THAN_OR_EQUAL: 'IS_LESS_THAN_OR_EQUAL'
};

exports.ResolutionType = exports.$Enums.ResolutionType = {
  AUTOMATIC: 'AUTOMATIC',
  AGENT: 'AGENT'
};

exports.IntegrationType = exports.$Enums.IntegrationType = {
  WHATSAPP: 'WHATSAPP',
  SLACK: 'SLACK'
};

exports.ChatType = exports.$Enums.ChatType = {
  MESSENGER: 'MESSENGER',
  FULLPAGE: 'FULLPAGE',
  INLINECHAT: 'INLINECHAT',
  PREVIEW: 'PREVIEW'
};

exports.Sender = exports.$Enums.Sender = {
  USER: 'USER',
  AI: 'AI',
  AGENT: 'AGENT'
};

exports.MessageType = exports.$Enums.MessageType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE'
};

exports.EvaluationResult = exports.$Enums.EvaluationResult = {
  OUT_OF_CONTEXT: 'OUT_OF_CONTEXT',
  PARTIAL_ANSWER: 'PARTIAL_ANSWER',
  LACK_OF_DEPTH: 'LACK_OF_DEPTH',
  OTHER: 'OTHER'
};

exports.AIAgentSource = exports.$Enums.AIAgentSource = {
  CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
  MARKETING: 'MARKETING',
  SALES: 'SALES',
  HUMAN_RESOURCES: 'HUMAN_RESOURCES',
  HEALTHCARE: 'HEALTHCARE',
  ECOMMERCE: 'ECOMMERCE',
  REAL_ESTATE: 'REAL_ESTATE',
  EDUCATION: 'EDUCATION',
  CONTENT_CREATORS: 'CONTENT_CREATORS',
  CUSTOM: 'CUSTOM'
};

exports.OnboardingMeetingStatus = exports.$Enums.OnboardingMeetingStatus = {
  NOT_SCHEDULED: 'NOT_SCHEDULED',
  SKIPPED: 'SKIPPED',
  SCHEDULED: 'SCHEDULED',
  DONE: 'DONE'
};

exports.OnboardingStatus = exports.$Enums.OnboardingStatus = {
  STEP_1: 'STEP_1',
  STEP_2: 'STEP_2',
  STEP_3: 'STEP_3',
  STEP_4: 'STEP_4',
  DONE: 'DONE',
  SKIPPED: 'SKIPPED'
};

exports.InvitationStatus = exports.$Enums.InvitationStatus = {
  PENDING: 'PENDING',
  DONE: 'DONE',
  EXPIRED: 'EXPIRED'
};

exports.WorkspaceRole = exports.$Enums.WorkspaceRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER'
};

exports.ResetPasswordTokenStatus = exports.$Enums.ResetPasswordTokenStatus = {
  PENDING: 'PENDING',
  DONE: 'DONE',
  EXPIRED: 'EXPIRED'
};

exports.APITokenScope = exports.$Enums.APITokenScope = {
  ALL: 'ALL',
  AI_FUNCTION: 'AI_FUNCTION'
};

exports.AuthProvider = exports.$Enums.AuthProvider = {
  CREDENTIAL: 'CREDENTIAL',
  GOOGLE: 'GOOGLE'
};

exports.BillingInterval = exports.$Enums.BillingInterval = {
  MONTHLY: 'MONTHLY',
  YEARLY: 'YEARLY',
  LIFETIME: 'LIFETIME',
  ONETIME: 'ONETIME'
};

exports.OpenAIOperation = exports.$Enums.OpenAIOperation = {
  REPLY: 'REPLY',
  USERINTENT: 'USERINTENT',
  AIFUNCTIONCHECK: 'AIFUNCTIONCHECK',
  IMPROVEWITHAI: 'IMPROVEWITHAI',
  FOLLOWUPQUESTIONS: 'FOLLOWUPQUESTIONS',
  EVALUATEMESSAGES: 'EVALUATEMESSAGES',
  GENERATEQUESTIONFROMDATASOURCE: 'GENERATEQUESTIONFROMDATASOURCE',
  EXPANDQUESTION: 'EXPANDQUESTION',
  GENERATE_QA: 'GENERATE_QA',
  TRANSCRIPT_IMAGE: 'TRANSCRIPT_IMAGE',
  GENERATE_IMAGE_ALT: 'GENERATE_IMAGE_ALT',
  FREE_TOOLS_COVER_LETTER_GENERATOR: 'FREE_TOOLS_COVER_LETTER_GENERATOR',
  FREE_TOOLS_DOCUMENT_SUMMARIZER: 'FREE_TOOLS_DOCUMENT_SUMMARIZER',
  FREE_TOOLS_RESUME_ANALYZER: 'FREE_TOOLS_RESUME_ANALYZER',
  FREE_TOOLS_BAR_CHART_GENERATOR: 'FREE_TOOLS_BAR_CHART_GENERATOR',
  FREE_TOOLS_CHATBOT_NAME_GENERATOR: 'FREE_TOOLS_CHATBOT_NAME_GENERATOR',
  FREE_TOOLS_COLUMN_CHART_GENERATOR: 'FREE_TOOLS_COLUMN_CHART_GENERATOR',
  FREE_TOOLS_GET_RESULTS: 'FREE_TOOLS_GET_RESULTS',
  FREE_TOOLS_IMAGE_ALT_TEXT_GENERATOR: 'FREE_TOOLS_IMAGE_ALT_TEXT_GENERATOR',
  FREE_TOOLS_INSTAGRAM_POST_GENERATOR: 'FREE_TOOLS_INSTAGRAM_POST_GENERATOR',
  FREE_TOOLS_LINE_CHART_GENERATOR: 'FREE_TOOLS_LINE_CHART_GENERATOR',
  FREE_TOOLS_META_INFORMATION_GENERATOR: 'FREE_TOOLS_META_INFORMATION_GENERATOR',
  FREE_TOOLS_PIE_CHART_GENERATOR: 'FREE_TOOLS_PIE_CHART_GENERATOR',
  FREE_TOOLS_PRIVACY_POLICY_SUMMARIZER: 'FREE_TOOLS_PRIVACY_POLICY_SUMMARIZER',
  FREE_TOOLS_TABLE_GENERATOR: 'FREE_TOOLS_TABLE_GENERATOR',
  FREE_TOOLS_TWEET_GENERATOR: 'FREE_TOOLS_TWEET_GENERATOR',
  FREE_TOOLS_YOUTUBE_POST_GENERATOR: 'FREE_TOOLS_YOUTUBE_POST_GENERATOR'
};

exports.ErrorType = exports.$Enums.ErrorType = {
  CRAWL_ERROR: 'CRAWL_ERROR',
  OTHER: 'OTHER'
};

exports.AttributeStatus = exports.$Enums.AttributeStatus = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED'
};

exports.AttributeDataType = exports.$Enums.AttributeDataType = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOLEAN: 'BOOLEAN',
  TIMESTAMP: 'TIMESTAMP'
};

exports.Prisma.ModelName = {
  Chatbot: 'Chatbot',
  AIFunction: 'AIFunction',
  AIFunctionLog: 'AIFunctionLog',
  Translation: 'Translation',
  ContactAttribute: 'ContactAttribute',
  Contact: 'Contact',
  Library: 'Library',
  Audience: 'Audience',
  AudienceLibrary: 'AudienceLibrary',
  FilterGroup: 'FilterGroup',
  FilterRule: 'FilterRule',
  Chat: 'Chat',
  AgentUnreadChat: 'AgentUnreadChat',
  ContactUnreadChat: 'ContactUnreadChat',
  Message: 'Message',
  MessageEvaluation: 'MessageEvaluation',
  ChatResolutionLog: 'ChatResolutionLog',
  Source: 'Source',
  SourceAudienceLog: 'SourceAudienceLog',
  Workspace: 'Workspace',
  Invitation: 'Invitation',
  ResetPasswordToken: 'ResetPasswordToken',
  ApiAccessToken: 'ApiAccessToken',
  ApiAccessTokenUsageLog: 'ApiAccessTokenUsageLog',
  User: 'User',
  WorkspaceAccess: 'WorkspaceAccess',
  Plan: 'Plan',
  AddOnPackage: 'AddOnPackage',
  WorkspaceAddOnPackage: 'WorkspaceAddOnPackage',
  MailLog: 'MailLog',
  TokenLog: 'TokenLog',
  AppSumoCode: 'AppSumoCode',
  WhatsappIntegration: 'WhatsappIntegration',
  SlackAppInstallation: 'SlackAppInstallation',
  ErrorLog: 'ErrorLog',
  ResyncLog: 'ResyncLog',
  AllowedContactAttribute: 'AllowedContactAttribute',
  SuggestionMessagesView: 'SuggestionMessagesView'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
